import jQuery from 'jquery';

export default function header() {
    jQuery(() => {
        // sticky header
        function transformHeader() {
            const scroll = jQuery(window).scrollTop();

            if (scroll > 0) {
                jQuery('.header')
                    .addClass('sticky');
            } else {
                jQuery('.header')
                    .removeClass('sticky');
            }
        }

        transformHeader();
        jQuery(window)
            .scroll(() => {
                transformHeader();
            });

        jQuery('.header__toolbar-menu a').on('click', (e) => {
            jQuery('.header__menu').toggleClass('opened');
        });

        jQuery('.header__toolbar-search-toggle').on('click', (e) => {
            jQuery('.header__toolbar-search input').fadeToggle();
        });

        let lastClick = null;

        function submenuDropdown() {
            jQuery('.header__menu > .header-nav__list > .header-nav__list-item:has(.header-nav__list)').on('click', function (e) {
                if (jQuery(window).width() < 992 && !jQuery(this).is(lastClick)) {
                    e.preventDefault();

                    jQuery('.header-nav__list .header-nav__list').slideUp();
                    jQuery(this).find('.header-nav__list').slideToggle();

                    lastClick = jQuery(this);
                }
            });
        }

        submenuDropdown();
    });
}
